import { render, staticRenderFns } from "./PermissionsFields.vue?vue&type=template&id=253cde32"
import script from "./PermissionsFields.vue?vue&type=script&lang=js"
export * from "./PermissionsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmFieldNewsPermissionRadios: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmCheckout/Fields/TlmFieldNewsPermissionRadios.vue').default})
